module.exports = __webpack_public_path__ + "img/not_deliver_address@2x.f41e7ccd.png";